document.addEventListener("DOMContentLoaded", () => {
  const oneTimeWrapper = document.querySelector('.shopify_subscriptions_app_block_label');
  const blocks = document.querySelectorAll(".shopify_subscriptions_app_block_label_children li");
  if (oneTimeWrapper !== null && blocks.length > 0 && blocks !== null) {
    oneTimeWrapper.classList.add('one-time-wrapper--flex');

    const wrapper = document.createElement("div");
    wrapper.id = "subscriptionDropdownWrapper";

    // Create header with radio and label hidden
    const header = document.createElement("div");
    header.className = "subscription-header";
    header.id = "subscription-header";

    const radio = document.createElement("div");
    const radioInner = document.createElement("div");
    radio.className = "subscription-radio";
    radio.id = "subscription-custom-radio";
    radioInner.className = "subscription-radio-inner";
    radio.appendChild(radioInner)


    const label = document.createElement("label");
    label.setAttribute("for", "subscribeAndSaveRadio");
    label.style.cursor = "pointer";

    header.appendChild(radio);


    //subscrition details 
    const details = document.createElement("div");
    details.id = "subscription-details";
    details.className = "subscription-details";
    const arrow = document.createElement('span');
    arrow.innerHTML = '▼';
    arrow.className = "subscription-arrow";
    if (blocks.length > 2) {
      details.appendChild(arrow);
      details.addEventListener("click", () => {
        const dropdown = document.getElementById("customSubscriptionDropdown");


        if (dropdown.classList.contains("show")) {
          arrow.style.transform = 'rotate(0deg)';
          document.getElementById("customSubscriptionDropdown").classList.remove("show");

        }
        else {
          document.getElementById("customSubscriptionDropdown").classList.add("show");
          arrow.style.transform = 'rotate(180deg)';
        }

      });
    }
    const badge = document.createElement("div");
    const price = document.createElement("div");

    // Dropdown
    const dropdown = document.createElement("div");
    dropdown.id = "customSubscriptionDropdown";

    blocks.forEach((block, index) => {

      // Ignore the first block (one-time purchase)
      const input = block.querySelector("input[type='radio']");

      if (!input || input.dataset.radioType === "one_time_purchase") {
        input.addEventListener("change", e => {
          document.getElementById("subscriptionDropdownWrapper").style.backgroundColor = "#fff";
          document.getElementById("subscriptionDropdownWrapper").style.boxShadow = '0 0 0 1px #dedede';
          document.getElementById("customSubscriptionDropdown").classList.remove("show");
          document.getElementById("subscription-header").style.fontWeight = "normal";

        });
        return;
      }


      const priceText = input.dataset.variantPrice.replace("USD", "").trim();
      let subtitle = block.querySelector(".shopify_subscriptions_app_block_label_children_subtitle")?.innerText.trim();

      const option = document.createElement("div");
      option.className = "custom-dropdown-option";
      option.value = input.dataset.sellingPlanId;
      option.dataset.radioSelector = `input[data-selling-plan-id="${input.dataset.sellingPlanId}"]`;
      option.dataset.price = priceText;
      const OldPrice = input.dataset.variantCompareAtPrice.replace("USD", "").trim();
      option.dataset.OldPrice = OldPrice;
      const ariaLabel = input.getAttribute("aria-label"); // e.g., "Deliver every 3 months, 11% off. Product price $48.95 USD"
      const match = ariaLabel.match(/(\d+)%\s*off/i);
      const discountPercentage = match ? match[1] : 0; // Default to 0 if no match found
      option.dataset.discountPercentage = `${discountPercentage}%`
      const monthsMatch = ariaLabel.match(/(\d+\s*months)/);
      const days = (monthsMatch ? Number(monthsMatch[0].replace("months", "")) : 1) * 30;
      subtitle = subtitle.replace(/every 3 months and save up to \d+%/, `every ${days} days`);
      option.dataset.subtitle = subtitle;

      const desiredOutput = monthsMatch && monthsMatch[1] ? monthsMatch[0].replace(" months", "-Month") + " Subscription" : "1-Month Subscription"; // Default to "3 months" if no match found
      option.dataset.months = desiredOutput;

      if (index == 0) {
        badge.className = "subscription-badge";
        badge.innerHTML = `<span  id="currentPorcentage">SAVE ${discountPercentage}%</span>`;
        label.textContent = `Subscribe & Save ${discountPercentage}%`;
        price.className = "subscription-price";
        price.innerHTML = `<span class="months medium">${desiredOutput}:</span>  <span class="old-price" id="currentPriceOldPrice">${OldPrice}</span> <span id="currentPrice" class="medium">${priceText}</span>
        <div class="subscription-description" id="currentDescripcion">${subtitle}</div>`;
        option.className = "custom-dropdown-option selected";
        radio.dataset.radioSelector = `input[data-selling-plan-id="${input.dataset.sellingPlanId}"]`;
      }
      const badgeOption = document.createElement("div");
      const priceOption = document.createElement("div");
      badgeOption.className = "subscription-badge";
      badgeOption.innerHTML = `<span  id="currentPorcentage">SAVE ${discountPercentage}%</span>`;
      priceOption.className = "subscription-price";
      priceOption.innerHTML = `<span class="months medium">${desiredOutput}:</span>  <span class="old-price" id="currentPriceOldPrice">${OldPrice}</span> <span id="currentPrice" class="medium">${priceText}</span>
        <div class="subscription-description" id="currentDescripcion">${subtitle}</div>`;
      option.appendChild(badgeOption);
      option.appendChild(priceOption);

      option.addEventListener("click", (e) => {
        const selectedOption = e.currentTarget;
        const selectedRadio = document.querySelector(selectedOption.dataset.radioSelector);
        const allOptions = document.querySelectorAll(".custom-dropdown-option");
        allOptions.forEach((opt) => {
          opt.classList.remove("selected");
        });
        e.currentTarget.classList.add("selected");
        if (selectedRadio) {

          selectedRadio.click()
          document.getElementById("subscriptionDropdownWrapper").style.backgroundColor = "#ededed";
          document.getElementById("subscriptionDropdownWrapper").style.boxShadow = '0 0 0 1px #4B4948';
          const priceText = selectedOption.dataset.price.replace("USD", "").trim();
          const OldPrice = selectedOption.dataset.OldPrice.replace("USD", "").trim();
          const subtitle = selectedOption.dataset.subtitle;
          const months = selectedOption.dataset.months;
          const discountPercentage = selectedOption.dataset.discountPercentage.replace("USD", "").trim();
          label.textContent = `Subscribe & Save ${discountPercentage}`;
          badge.innerHTML = `<span  id="currentPorcentage">SAVE ${discountPercentage}</span>`;
          price.innerHTML = `<span class="months medium">${months}:</span>  <span class="old-price" id="currentPriceOldPrice">${OldPrice}</span> <span id="currentPrice" class="medium">${priceText}</span>
        <div class="subscription-description" id="currentDescripcion">${subtitle}</div>`;
          dropdown.style.backgroundColor = "#fff";
          dropdown.style.borderColor = "#fff";
          radio.click();
          radio.dataset.radioSelector = selectedOption.dataset.radioSelector;
        }
      });
      dropdown.appendChild(option);
    });

    // Insert everything into the container
    details.appendChild(badge);
    details.appendChild(price);
    details.appendChild(dropdown);
    header.appendChild(label);
    wrapper.appendChild(header);
    wrapper.appendChild(details);
    wrapper.addEventListener("click", (e) => {
      radio.click();
      document.getElementById("subscription-header").classList.add("bold");
      document.getElementById("subscriptionDropdownWrapper").style.backgroundColor = "#ededed";
      document.getElementById("subscriptionDropdownWrapper").style.boxShadow = '0 0 0 1px #4B4948';
      document.getElementById("subscription-details").classList.add("show");

    });
    const oneTimeBlock = document.querySelector(".one-time-wrapper--flex");
    if (oneTimeBlock) {
      oneTimeBlock.insertAdjacentElement("afterend", wrapper);
    }
    oneTimeBlock.addEventListener("click", (e) => {
      arrow.style.transform = 'rotate(0deg)';
      document.getElementById("subscription-details").classList.remove("show");
      document.getElementById("customSubscriptionDropdown").classList.remove("show");
      radio.classList.remove('selected');
      document.querySelector("input[data-radio-type='one_time_purchase']").click()
      document.getElementById("subscriptionDropdownWrapper").style.backgroundColor = "#fff";
      document.getElementById("subscriptionDropdownWrapper").style.boxShadow = '0 0 0 1px #dedede';
      document.getElementById("subscription-header").classList.remove("bold");
    });
    radio.addEventListener('click', () => {
      // Only selected if not selected (radio-like behavior)
      if (!radio.classList.contains('selected')) {
        radio.classList.add('selected');
      }

      const selectedRadio = document.querySelector(radio.dataset.radioSelector);
      if (selectedRadio) {
        selectedRadio.click();
      }
    });
  }

});